import { createSlice } from '@reduxjs/toolkit';
import { transactionsAdapter } from './trackedTransaction';
export const transactionSlicePrefix = 'sfTransactions';
export const createTransactionSlice = () => createSlice({
    name: transactionSlicePrefix,
    initialState: transactionsAdapter.getInitialState(),
    reducers: {
        upsertTransaction: transactionsAdapter.upsertOne,
    },
});
//# sourceMappingURL=createTransactionSlice.js.map